export const SUPPORTED_DATA_SOURCES = ['uql'];
export const ASSISTED_QUERY_BUILDER = 0;
export const QUERY_BOX = 1;

export enum EDITOR_MODES {
  QUERY = 'query',
  BUILDER = 'builder',
}
export enum FETCH_FIELDS {
  ID = 'id',
  COUNT = 'count',
  ATTRIBUTES = 'attributes',
  METRICS = 'metrics',
  EVENTS = 'events',
  UNSUPPORTED = 'UNSUPPORTED',
}

export enum DEFAULT_ALIAS {
  ID = 'a',
  COUNT = 'count',
  ATTRIBUTES = 'attr',
  METRICS = 'met',
  EVENTS = 'event',
  UNSUPPORTED = 'name',
}

export enum METRIC_SELECTOR {
  ALLSOURCES = 'All',
}

export enum LIMITS {
  TOPOLOGY = 'topology',
  METRICS = 'metrics',
}

export enum ORDER {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}
